export default __webpack_public_path__ + "static/media/medium.3ddac089.svg";